<header>
  <button type="button" class="mob-menu-icon" aria-label="Open menu">
    <span></span>
    <span></span>
    <span></span>
  </button>
  <div class="right-section">
    <button type="button" class="notifications" (click)="toggleNotificationPopup()" aria-label="View notifications">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12 2C10.3475 2 8.7627 2.66154 7.59421 3.8391C6.42572 5.01665 5.76927 6.61376 5.76927 8.27907C5.76927 11.4321 5.09976 13.4079 4.46919 14.5729C4.15295 15.1572 3.84274 15.5446 3.62247 15.7789C3.51215 15.8963 3.42392 15.9757 3.36815 16.0225C3.34025 16.046 3.32045 16.0613 3.31005 16.0691L3.30208 16.0749C3.05265 16.2464 2.94208 16.5615 3.02976 16.8533C3.11817 17.1476 3.38728 17.3488 3.69236 17.3488H20.3076C20.6127 17.3488 20.8818 17.1476 20.9702 16.8533C21.0579 16.5615 20.9474 16.2465 20.6979 16.0749L20.6899 16.0691C20.6795 16.0613 20.6597 16.046 20.6319 16.0225C20.5761 15.9757 20.4879 15.8963 20.3775 15.7789C20.1573 15.5446 19.847 15.1572 19.5308 14.5729C18.9002 13.4079 18.2307 11.4321 18.2307 8.27907C18.2307 6.61376 17.5743 5.01665 16.4058 3.8391C15.2373 2.66154 13.6525 2 12 2ZM18.3153 15.2411C18.4603 15.5089 18.6061 15.7456 18.7478 15.9535H5.25218C5.39385 15.7456 5.53974 15.5089 5.68473 15.2411C6.43877 13.8479 7.15387 11.6377 7.15387 8.27907C7.15387 6.98383 7.66445 5.74163 8.57327 4.82576C9.4821 3.90988 10.7147 3.39535 12 3.39535C13.2853 3.39535 14.5179 3.90988 15.4267 4.82576C16.3356 5.74163 16.8461 6.98383 16.8461 8.27907C16.8461 11.6377 17.5612 13.8479 18.3153 15.2411ZM9.84947 19.1293C9.67815 18.7848 9.26217 18.6455 8.92035 18.8181C8.57853 18.9908 8.44031 19.41 8.61162 19.7545C8.94273 20.4202 9.42431 20.9857 10.0179 21.3845C10.6126 21.784 11.2964 22 11.9998 22C12.7032 22 13.3869 21.784 13.9816 21.3845C14.5752 20.9857 15.0568 20.4202 15.3879 19.7545C15.5592 19.41 15.421 18.9908 15.0792 18.8181C14.7373 18.6455 14.3214 18.7848 14.15 19.1293C13.9183 19.5952 13.592 19.9692 13.2136 20.2235C12.8363 20.4769 12.4181 20.6047 11.9998 20.6047C11.5815 20.6047 11.1632 20.4769 10.7859 20.2235C10.4075 19.9692 10.0812 19.5952 9.84947 19.1293Z"
          fill="black" />
      </svg>
      <span class="notification-badge" *ngIf="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>
    <div class="user-details-wrapper">
      <button type="button" class="user-details" (click)="toggleDropdown()" aria-haspopup="true"
        [attr.aria-expanded]="isDropdownOpen">
        <img src="../../../../assets/images/headerPrPic.png" alt="User profile picture" />
        <span class="email"> {{ userInfo?.username }}</span>
        <span class="arrow"></span>
      </button>
      <div class="dropdown-menu" [class.show]="isDropdownOpen" role="menu">
        <button type="button" class="dropdown-item" (click)="toggleProfilePopup()" role="menuitem">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
              fill="currentColor" />
          </svg>
          <span>Profile</span>
        </button>
        <button type="button" class="dropdown-item" (click)="logout()" role="menuitem">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 17L21 12L16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M21 12H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </div>
  <app-notification-popup *ngIf="showNotificationPopup" (close)="closeNotificationPopup()" (action)="handleNotificationAction($event)">
  </app-notification-popup>
  <app-profile-popup *ngIf="showProfilePopup" [show]="showProfilePopup" (close)="closeProfilePopup()"
    (openPricing)="handleProfileSubscribe()">
  </app-profile-popup>
</header>

<ng-container *ngIf="showPricingModal">
  <div class="pricing-modal">
    <div class="popup-wrapper">
      <div class="popup-box">
        <div class="popup-header">
          <span class="head-text">Pricing Plans</span>
          <button class="close" (click)="closePricingModal()" aria-label="Close pricing modal"></button>
        </div>
        <div class="popup-content">
          <div *ngIf="showSubscriptionSuccess" class="subscription-success">
            <div class="success-icon">✅</div>
            <ng-container *ngIf="boosterSuccessMessage">
              <h1 class="success-title">Booster Pack added Successful!</h1>
            </ng-container>
            <ng-container *ngIf="!boosterSuccessMessage">
              <h1 class="success-title">Subscription Successful!</h1>
            </ng-container>
            <div class="subscription-details-card">
              <h3>Your Subscription Details</h3>
              <div class="subscription-grid">
                <div class="detail-item">
                  <span class="detail-label">Plan Name</span>
                  <span class="detail-value">{{ subscriptionInfo?.planName || 'N/A' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Billing Cycle</span>
                  <span class="detail-value">{{ subscriptionInfo?.billingCycle || 'N/A' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Plan Expiry</span>
                  <span class="detail-value">{{ subscriptionInfo?.planExpiry || 'N/A' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Contact Credits</span>
                  <span class="detail-value">{{ subscriptionInfo?.availableContactCredits || 0 }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Email Credits</span>
                  <span class="detail-value">{{ subscriptionInfo?.availableEmailCredits || 0 }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">AI Co-Pilot Campaign Credits</span>
                  <span class="detail-value">{{ subscriptionInfo?.availableAgentCampaignCredits || 0 }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">AI Research Queries</span>
                  <span class="detail-value">{{ subscriptionInfo?.availableAgentResearchCredits || 0 }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Auto Renewal</span>
                  <span class="detail-value">
                    <span class="status-badge"
                      [ngClass]="{'active': subscriptionInfo?.autoRenewal, 'inactive': !subscriptionInfo?.autoRenewal}">
                      {{ subscriptionInfo?.autoRenewal ? 'Enabled' : 'Disabled' }}
                    </span>
                  </span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">Status</span>
                  <span class="detail-value">
                    <span class="status-badge"
                      [ngClass]="{'active': subscriptionInfo?.subscribed, 'inactive': !subscriptionInfo?.subscribed}">
                      {{ subscriptionInfo?.subscribed ? 'Active' : 'Inactive' }}
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div class="success-actions">
              <button *ngIf="subscriptionInfo?.receiptUrl && !boosterSuccessMessage" class="pricing-cta-btn"
                (click)="viewReceipt()">View Receipt</button>
            </div>
          </div>
          <div *ngIf="showSubscriptionFailure" class="subscription-failure">
            <div class="failure-icon">❌</div>
            <h1 class="failure-title">Payment Failed</h1>
            <p class="failure-message">There was a problem processing your payment. Please try again or contact support.
            </p>
          </div>
          <div *ngIf="!showSubscriptionSuccess && !showSubscriptionFailure">

            <section class="pricing-hero">
              <h1 class="pricing-hero-title">
                Pricing that scales with your business
              </h1>
              <p class="pricing-hero-desc">
                Simple, transparent plans. No long-term contracts or hidden fees.
              </p>
              <div class="pricing-toggle-row">
                <span class="pricing-toggle-label">Monthly</span>
                <label class="pricing-toggle-switch">
                  <input type="checkbox" [checked]="isAnnualBilling" (change)="toggleBilling()">
                  <span class="pricing-toggle-slider"></span>
                </label>
                <span class="pricing-toggle-label">Annually</span>
                <span class="pricing-toggle-save">Save up to 20%</span>
              </div>
            </section>
            <section>
              <div class="pricing-table-wrapper">
                <table class="pricing-table">
                  <thead>
                    <tr>
                      <th class="pricing-feature">Features</th>
                      <th *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">
                        <div class="plan-header">
                          {{ plan.name }}
                        </div>
                        <span class="text-3xl font-bold">
                          ${{ getPlanPrice(plan) }}
                          <span class="text-base font-medium"> {{ isAnnualBilling ? '/yr' : '/mo'}}</span>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- CTA Row -->
                    <tr class="pricing-bg-light">
                      <td></td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">
                        <button (click)="subscribe(plan)" class="pricing-cta-btn" [disabled]="isButtonDisabled(plan)"
                          [ngClass]="{
                            'primary': plan.name !== 'Free',
                            'upgrade': getPlanButtonText(plan) === 'Upgrade',
                            'downgrade': getPlanButtonText(plan) === 'Downgrade'
                          }">
                          {{ getPlanButtonText(plan) }}
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td [attr.colspan]="plans.length + 1" class="pricing-section-header">Core Platform Limits</td>
                    </tr>
                    <tr>
                      <td class="pricing-feature">Active Target Accounts</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">{{
                        plan.maxTargetAccounts }}</td>
                    </tr>
                    <tr class="pricing-bg-light">
                      <td class="pricing-feature">Users / Seats</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">{{
                        plan.maxUsers }}</td>
                    </tr>
                    <tr>
                      <td class="pricing-feature">AI Assistant</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">{{
                        plan.maxAssistants }}</td>
                    </tr>
                    <!-- Usage & Credits -->
                    <tr>
                      <td [attr.colspan]="plans.length + 1" class="pricing-section-header">Usage & Credits</td>
                    </tr>
                    <tr>
                      <td class="pricing-feature">Verified Contacts Revealed</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">{{
                        plan.maxContacts }} / mo</td>
                    </tr>
                    <tr class="pricing-bg-light">
                      <td class="pricing-feature">Emails Sent / month</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">{{
                        plan.maxEmails }} / mo</td>
                    </tr>
                    <tr>
                      <td class="pricing-feature">AI Co-Pilot Campaign Credits</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">{{
                        plan.maxAgentCampaignCredits }} / mo</td>
                    </tr>
                    <tr>
                      <td class="pricing-feature">AI Research Queries</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">{{
                        plan.maxAgentResearchCredits }} / mo</td>
                    </tr>
                    <!-- Features & Support -->
                    <tr>
                      <td [attr.colspan]="plans.length + 1" class="pricing-section-header">Features & Support</td>
                    </tr>
                    <tr>
                      <td class="pricing-feature">Scoring Algorithm</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">{{
                        plan.scoringMode | titlecase }}</td>
                    </tr>
                    <tr class="pricing-bg-light">
                      <td class="pricing-feature">CRM Integration</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">
                        {{ plan.integrationMode === 'BIDIRECTIONAL' ? 'Bi-directional Sync' : plan.integrationMode ===
                        'MANUAL' ? 'Manual Export' : (plan.integrationMode | titlecase) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="pricing-feature">Support</td>
                      <td *ngFor="let plan of plans" [ngClass]="{'pricing-highlight': plan.name === 'Growth'}">
                        {{ plan.supportMode === 'PRIORITY' ? 'Priority Email & Chat' : plan.supportMode === 'DEDICATED'
                        ? 'Dedicated Account Manager' : (plan.supportMode | titlecase) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section class="pricing-hero"
              *ngIf="subscriptionService.info?.planId && subscriptionService.info?.planName !=='Free'">
              <h2 class="pricing-hero-title">Need more power? Add a Booster Pack.</h2>
              <p class="pricing-hero-desc">Add to any paid plan, anytime.</p>
              <div class="pricing-table-wrapper">
                <table class="pricing-table">
                  <thead>
                    <tr>
                      <th class="pricing-feature">Booster Pack Type</th>
                      <th *ngFor="let tier of getBoosterTiers()">Tier {{ tier + 1 }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let type of boosterTypes">
                      <ng-container *ngIf="planAddOns && planAddOns[type]">
                        <td class="pricing-feature">{{ getBoosterTypeLabel(type) }}</td>
                        <td *ngFor="let tier of getBoosterTiers(); let i = index">
                          <ng-container *ngIf="planAddOns && planAddOns[type] && planAddOns[type][i]">
                            <label style="display: flex; align-items: center; gap: 4px;">
                              <input type="checkbox" [checked]="selectedAddOnIds.includes(planAddOns[type][i].id)"
                                (change)="onAddOnCheckboxChange(planAddOns[type][i].id, getChecked($event))" />
                              +{{ planAddOns[type][i].creditUnits }} for ${{ planAddOns[type][i].price }}/mo
                            </label>
                          </ng-container>
                        </td>
                      </ng-container>

                    </tr>
                  </tbody>
                </table>
                <div style="margin: 16px;">
                  <button class="pricing-cta-btn" (click)="onAddPlanBooster()">Add Plan</button>
                </div>
              </div>
            </section>
            <!-- FAQ & ENTERPRISE CTA SECTION -->
            <div class="pricing-enterprise-cta">
              <div class="pricing-enterprise-cta-title">Looking for a custom solution?</div>
              <div class="pricing-enterprise-cta-desc">For teams requiring custom integrations, white-labeling, or
                unlimited scale, our enterprise plan is built for you.</div>
              <button class="pricing-enterprise-cta-btn">Contact Sales</button>
            </div>
            <div class="pricing-faq">
              <div class="pricing-faq-title">Frequently Asked Questions</div>
              <div class="pricing-faq-list">
                <details open>
                  <summary>What payment methods do you accept?</summary>
                  <p>We accept all major credit cards, including Visa, Mastercard, American Express, and Discover. We
                    also support payments via PayPal.</p>
                </details>
                <details>
                  <summary>Can I change my plan later?</summary>
                  <p>Yes, you can upgrade, downgrade, or cancel your plan at any time from your account settings.
                    Changes will be prorated.</p>
                </details>
                <details>
                  <summary>Do you offer discounts for non-profits?</summary>
                  <p>Yes, we offer a discount for registered non-profit organizations. Please contact our sales team
                    with your documentation to learn more.</p>
                </details>
              </div>
            </div>
          </div>
        </div>
        <div class="popup-buttons-wrapper" *ngIf="!showSubscriptionSuccess">
          <button class="pricing-cta-btn" (click)="closePricingModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>